import './button.css'

function Button({ text }) {
  return <div className="signInButton">{text}</div>
}

export default Button
